import React, { ReactNode } from 'react';
import { Card, Group, Stack, Text, Checkbox, ActionIcon } from '@mantine/core';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';

interface CVItemCardProps {
  title: string;
  subtitle?: string;
  dates?: string;
  description?: string | ReactNode;
  included?: boolean;
  onEdit?: () => void;
  onDelete?: () => void;
  onToggleInclude?: () => void;
  isEditMode: boolean;
}

export function CVItemCard({ 
  title, 
  subtitle, 
  dates, 
  description, 
  included = true, 
  onEdit, 
  onDelete, 
  onToggleInclude,
  isEditMode
}: CVItemCardProps) {
  return (
    <Card 
      mb="md" 
      padding="md" 
      withBorder
      style={{ borderColor: 'var(--mantine-color-gray-3)' }}
    >
      <Group justify="space-between" align="flex-start">
        <Stack gap="xs">
          <Text fw={500}>{title}</Text>
          {subtitle && <Text size="sm" c="dimmed">{subtitle}</Text>}
          {dates && <Text size="sm">{dates}</Text>}
        </Stack>
        {isEditMode && (
          <Group gap={8}>           
            <ActionIcon variant="subtle" color="gray.7" onClick={onEdit}>
              <PencilIcon style={{ width: 16, height: 16 }} />
            </ActionIcon>
            <ActionIcon variant="subtle" color="red" onClick={onDelete}>
              <TrashIcon style={{ width: 16, height: 16 }} />
            </ActionIcon>
          </Group>
        )}
      </Group>
      {description && (
        typeof description === 'string' 
          ? <Text size="sm" mt="sm">{description}</Text>
          : <div className="mt-3">{description}</div>
      )}
    </Card>
  );
} 
